module.exports = __webpack_public_path__ + "img/check-white.0f26e063.svg";